import { useState } from "react"
import useOtp from "../../../hooks/use-otp"
import { Button } from "../../ui/button"
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../../ui/input-otp"
import { useFormStore } from "../../../stores/use-form-store"
import type { UseFormReturn } from "react-hook-form"
import type { FIELD } from "../../../types/form-types"
import { parsePhoneNumber } from "react-phone-number-input"
import { toast } from "sonner"
import { CountDownTimer } from "@zenithui/time-picker"

export default function OTPInputField({
	resendOTPTimer,
	type,
	email,
	// countryCode,
	phoneNumber,
	form,
	field,
	setIsTimerExpired,
}: {
	resendOTPTimer: number
	type: "EMAIL" | "MOBILE"
	email?: string
	// countryCode?: string
	phoneNumber?: string
	form: UseFormReturn
	field: FIELD
	setIsTimerExpired: (val: boolean) => void
}) {
	const [showOtpField, setShowOtpField] = useState<boolean>(false)
	const [isSendOtp, setIsSendOtp] = useState(false)
	const { useSendOtp, useVerifyOtp } = useOtp()
	const { setVerifiedFields, applicationId, config } = useFormStore()
	const { mutateAsync: verifyOtp } = useVerifyOtp(applicationId || "")
	const { mutateAsync: sendOtp } = useSendOtp(type)
	const [otp, setOtp] = useState("")
	// const [error, setError] = useState<string | null>(null)
	const [info, setInfo] = useState<string | null>(null)

	const handleSendOtp = async () => {
		const isValid = await form.trigger(field.field_id)

		if (!isValid) {
			return
		}

		setIsSendOtp(true)
		setIsTimerExpired(false)
		setShowOtpField(true)
		const number = parsePhoneNumber(phoneNumber || "")

		await sendOtp({
			email,
			countryCode: "+" + number?.countryCallingCode,
			phoneNumber: number?.nationalNumber,
			universityId: config?.university_id || "",
			applicationId: applicationId || "",
			batchId: config?.batch_id || "",
		})
	}

	// const handleResendOtp = async () => {
	// 	setIsSendOtp(true)
	// 	await sendOtp({
	// 		email,
	// 		countryCode,
	// 		phoneNumber,
	// 	})
	// }

	const handleVerifyOtp = async (otp: string) => {
		const number = parsePhoneNumber(phoneNumber || "")

		const { is_valid } = await verifyOtp({
			type,
			email,
			countryCode: "+" + number?.countryCallingCode,
			phoneNumber: number?.nationalNumber,
			otp,
			field_id: field.field_id,
			universityId: config?.university_id || "",
			batchId: config?.batch_id || "",
		})

		if (is_valid) {
			setInfo("verified")
			setVerifiedFields({ fieldId: field.field_id, isVerified: true })
			form.clearErrors(field.field_id)
		} else {
			toast.error("OTP expired or invalid")
		}
	}

	return (
		<>
			{info && info === "verified" ? (
				<p>
					<p className="text-green-500">{info}</p>
				</p>
			) : (
				<div>
					{showOtpField ? (
						<div className="space-y-3 pl-2">
							<InputOTP
								maxLength={6}
								onChange={e => {
									setOtp(e)
								}}
							>
								<InputOTPGroup>
									<InputOTPSlot index={0} />
									<InputOTPSlot index={1} />
									<InputOTPSlot index={2} />
									<InputOTPSlot index={3} />
									<InputOTPSlot index={4} />
									<InputOTPSlot index={5} />
								</InputOTPGroup>
							</InputOTP>

							{isSendOtp ? (
								<CountDownTimer
									startTime={new Date(
										Date.now(),
									).toISOString()}
									onExpired={() => {
										setIsTimerExpired(true)
										setIsSendOtp(false)
									}}
									description="Resend OTP"
									type="seconds"
									duration={resendOTPTimer}
									className="mr-3 mt-3 inline-block text-red-500"
								/>
							) : (
								<Button
									type="button"
									variant={"ghost"}
									onClick={handleSendOtp}
								>
									Resend Otp
								</Button>
							)}

							{/* {error && <p className="text-red-600">{error}</p>} */}

							<Button
								disabled={otp.length < 6}
								onClick={() => handleVerifyOtp(otp)}
								type="button"
							>
								verify otp
							</Button>
						</div>
					) : (
						<Button
							type="button"
							onClick={handleSendOtp}
							className="mt-3"
						>
							Send OTP
						</Button>
					)}
				</div>
			)}
		</>
	)
}
